// src/features/index.js

const features = {
  upworkIntegration: false,
  // add other features here
};

export default features;